import { REMOVE_FILE_FOR_UPLOAD, SAVE_FILE_FOR_UPLOAD } from '../constants';

export const initialState = {
};

export const fileUploadReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SAVE_FILE_FOR_UPLOAD:
      return {
        ...state,
        file: payload.file
      };
    case REMOVE_FILE_FOR_UPLOAD:
      return {
        ...state,
        file: null
      };
    default:
      return state;
  }
};
